import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import Button, {
  ButtonVariant,
  ButtonType,
} from "common/basicComponents/Button";
import Page from "common/page/Page";
import Header from "common/page/Header";
import PartnerForm from "./PartnerForm";
import Content from "common/page/Content";
import {
  partnerDataToValues,
  partnerValuesToPayload,
} from "utils/PartnerUtils";
import { updatePartner } from "./PartnerActions";
import {
  addNotification,
  NotificationVariant,
} from "components/notifications/NotificationSlice";
import ValidationSchema from "./PartnerForm.schema";
import { getUserPartners } from "components/auth/AuthActions";
import { setPartnerById } from "components/auth/AuthActions";

const EditPartner = () => {
  const { t } = useTranslation("partners");
  const { partner, user } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const onSubmit = (values, form) => {
    setLoading(true);
    const editedData = partnerValuesToPayload(partner, values);

    updatePartner(values.id, editedData, form).then((ok) => {
      form.setSubmitting(false);
      setLoading(false);
      if (ok) {
        dispatch(
          addNotification({
            variant: NotificationVariant.SUCCESS,
            message: t("common:form.savedSuccessfully"),
          })
        );

        getUserPartners(user.id).then(() => {
          setPartnerById(partner.id);
        });
      }
    });
  };

  return (
    <Page>
      <Header
        title={t("editTitle")}
        button={
          <Button
            minWidth="13rem"
            type={ButtonType.SUBMIT}
            variant={ButtonVariant.GREEN}
            text={t("common:button.save")}
            form="partner-form"
            isLoading={loading}
          />
        }
      />
      <Content>
        <Formik
          initialValues={partnerDataToValues(partner)}
          validationSchema={ValidationSchema}
          onSubmit={onSubmit}
        >
          <PartnerForm />
        </Formik>
      </Content>
    </Page>
  );
};

export default EditPartner;
